import React, { useState } from "react";

// Modal component
const Modal = ({ title, children, open, onClose }) => {
  if (!open) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.6)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          background: "#fff",
          color: "#222",
          borderRadius: 16,
          maxWidth: 700,
          width: "90vw",
          padding: "2rem",
          boxShadow: "0 8px 32px #0003",
          fontFamily: "Inter, Arial, sans-serif",
          position: "relative",
        }}
      >
        <h2
          style={{
            fontSize: "2rem",
            fontWeight: 800,
            color: "#7C3AED",
            marginBottom: "1.5rem",
          }}
        >
          {title}
        </h2>
        <div
          style={{ maxHeight: "60vh", overflowY: "auto", marginBottom: "2rem" }}
        >
          {children}
        </div>
        <div
          style={{ display: "flex", justifyContent: "flex-end", gap: "1rem" }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "0.75rem 2rem",
              borderRadius: 8,
              background: "#A855F7",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            OK
          </button>
          <button
            onClick={onClose}
            style={{
              padding: "0.75rem 2rem",
              borderRadius: 8,
              background: "#ddd",
              color: "#333",
              fontWeight: "bold",
              border: "none",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
const CountDownPage = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [data, setData] = useState("");
  const [modal, setModal] = useState(""); // "terms", "privacy", "disclaimers"

  const handleSubmit = () => {
    if (!email) {
      setMessage("⚠️ Please enter an email address.");
      return;
    }

    // Create hidden iframe for response
    const iframe = document.createElement("iframe");
    iframe.name = "hidden_iframe";
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    // Create form dynamically
    const form = document.createElement("form");
    form.method = "POST";
    form.action =
      "https://script.google.com/macros/s/AKfycbyIU2l0IkCtZ2e9zbyWFuUAk1_ZWRA2XeYKxV2Xd9pB6SlOBcpgzMwotDMEQOS7IuWQsw/exec";
    form.target = "hidden_iframe";

    // Email input
    const emailInput = document.createElement("input");
    emailInput.type = "hidden";
    emailInput.name = "email";
    emailInput.value = email;
    form.appendChild(emailInput);

    // Data input
    const dataInput = document.createElement("input");
    dataInput.type = "hidden";
    dataInput.name = "data";
    dataInput.value = data;
    form.appendChild(dataInput);

    // Add form to DOM & submit
    document.body.appendChild(form);
    form.submit();

    // Clean up
    setTimeout(() => {
      document.body.removeChild(form);
      document.body.removeChild(iframe);
    }, 1000);

    setMessage("✅ Successfully subscribed! Get ready for launch!");
    setEmail("");
    setData("");
  };

  const features = [
    { icon: "🚀", text: "Fair Launch" },
    { icon: "🛡️", text: "No Presale" },
    { icon: "🔒", text: "LP Locked" },
    { icon: "🛡️", text: "Contract Renounced" },
    { icon: "👥", text: "Community-Driven" },
    { icon: "🏛️", text: "No Central Authority" },
  ];

  const containerStyle = {
    minHeight: "100vh",
    background:
      "linear-gradient(135deg, #6B46C1 0%, #7C3AED 25%, #8B5CF6 50%, #A855F7 75%, #C084FC 100%)",
    fontFamily:
      'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: "#ffffff",
    padding: "clamp(10px, 3vw, 20px)",
    position: "relative",
    overflow: "hidden",
  };

  const floatingStyle1 = {
    position: "absolute",
    width: "300px",
    height: "300px",
    borderRadius: "50%",
    background:
      "linear-gradient(45deg, rgba(255, 234, 0, 0.1), rgba(255, 145, 0, 0.1))",
    top: "10%",
    left: "-10%",
    animation: "float 8s ease-in-out infinite",
    zIndex: 1,
  };

  const floatingStyle2 = {
    position: "absolute",
    width: "200px",
    height: "200px",
    borderRadius: "50%",
    background:
      "linear-gradient(45deg, rgba(128, 0, 255, 0.1), rgba(102, 0, 204, 0.1))",
    top: "60%",
    right: "-5%",
    animation: "float 6s ease-in-out infinite 2s",
    zIndex: 1,
  };

  const mainContentStyle = {
    position: "relative",
    zIndex: 2,
    maxWidth: "1200px",
    margin: "0 auto",
    textAlign: "center",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "clamp(2rem, 5vw, 4rem)",
    padding: "clamp(1rem, 3vw, 2rem) 0",
  };

  const logoSectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "clamp(0.5rem, 2vw, 1rem)",
    marginBottom: "clamp(1rem, 3vw, 2rem)",
  };

  const logoImageStyle = {
    //   // width: "clamp(120px, 15vw, 200px)",
    //   // height: "clamp(120px, 15vw, 200px)",
    //   // borderRadius: "50%",
    //   // animation: "bounce 2s infinite",
    //   // boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
    //   // border: "4px solid #FEF08A",
    //   // objectFit: "cover",
  };

  const coinOverlayStyle = {
    fontSize: "clamp(1.5rem, 3vw, 2.5rem)",
    position: "absolute",
    top: "-10px",
    right: "-10px",
    animation: "pulse 2s infinite",
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "50%",
    width: "clamp(40px, 6vw, 60px)",
    height: "clamp(40px, 6vw, 60px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
  };

  const titleStyle = {
    fontSize: "clamp(2rem, 8vw, 5rem)",
    fontWeight: "900",
    textShadow: "0 4px 8px rgba(177, 246, 39, 0.14)",
    margin: "0",
    background: "linear-gradient(45deg,rgb(243, 216, 12), #F59E0B)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  };

  const taglineStyle = {
    fontSize: "clamp(1rem, 3vw, 1.5rem)",
    fontWeight: "bold",
    color: "#FEF08A",
    animation: "pulse 2s infinite",
    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
    padding: "0.5rem 1rem",
    background: "rgba(0,0,0,0.2)",
    borderRadius: "25px",
    border: "2px solid rgba(254, 240, 138, 0.3)",
  };

  const heroStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    marginBottom: "clamp(2rem, 4vw, 3rem)",
    padding: "0 clamp(1rem, 3vw, 2rem)",
  };

  const subtitleStyle = {
    fontSize: "clamp(1.8rem, 6vw, 4rem)",
    fontWeight: "bold",
    marginBottom: "clamp(1rem, 2vw, 1.5rem)",
    textShadow: "0 4px 8px rgba(0,0,0,0.5)",
    lineHeight: "1.2",
  };

  const descriptionStyle = {
    fontSize: "clamp(1rem, 3vw, 1.3rem)",
    lineHeight: "1.6",
    color: "#F3F4F6",
    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
    maxWidth: "700px",
    margin: "0 auto",
  };

  const formSectionStyle = {
    maxWidth: "700px",
    margin: "0 auto",
    marginBottom: "clamp(2rem, 4vw, 3rem)",
    padding: "0 clamp(1rem, 3vw, 2rem)",
  };

  const formTitleStyle = {
    fontSize: "clamp(1.5rem, 4vw, 2rem)",
    fontWeight: "bold",
    marginBottom: "clamp(0.5rem, 1vw, 0.75rem)",
    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
  };

  const formDescStyle = {
    fontSize: "clamp(1rem, 2.5vw, 1.2rem)",
    color: "#F3F4F6",
    marginBottom: "clamp(1rem, 2vw, 1.5rem)",
    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
  };

  const inputContainerStyle = {
    display: "flex",
    flexDirection:
      window.innerWidth && window.innerWidth < 640 ? "column" : "row",
    gap: "clamp(0.5rem, 1.5vw, 1rem)",
    marginBottom: "clamp(1rem, 2vw, 1.5rem)",
    alignItems: "stretch",
  };

  const inputStyle = {
    flex: "1",
    padding: "clamp(0.75rem, 2vw, 1.25rem)",
    borderRadius: "15px",
    border: "3px solid #ffffff",
    backgroundColor: "#ffffff",
    color: "#374151",
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    fontWeight: "600",
    outline: "none",
    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
    minHeight: "50px",
  };

  const buttonStyle = {
    padding: "clamp(0.75rem, 2vw, 1.25rem) clamp(1.5rem, 4vw, 2.5rem)",
    background: "linear-gradient(45deg, #FEF08A, #F59E0B)",
    color: "#000000",
    border: "none",
    borderRadius: "15px",
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
    minHeight: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const messageStyle = {
    padding: "1rem",
    borderRadius: "12px",
    fontWeight: "bold",
    textAlign: "center",
    fontSize: "1.1rem",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  };

  const featuresGridStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "1rem",
    maxWidth: "1100px",
    margin: "0 auto",
    marginBottom: "3rem",
  };

  // const featureCardStyle = {
  //   backgroundColor: "rgba(255, 255, 255, 0.95)",
  //   padding: "1rem 1.5rem",
  //   borderRadius: "25px",
  //   border: "2px solid #ffffff",
  //   boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
  //   transition: "all 0.3s ease",
  //   minWidth: "fit-content",
  //   whiteSpace: "nowrap",
  // };

  const featureCardStyle = {
    backgroundColor: "rgba(255, 255, 255, 0.95)",
    padding: "1rem 1rem",
    borderRadius: "25px",
    border: "2px solid #ffffff",
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
    width: "220px", // Increased width
    minHeight: "70px", // Decreased height
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0.5rem",
  };

  // const featureContentStyle = {
  //   display: "flex",
  //   alignItems: "center",
  //   gap: "1rem",
  // };

  const featureContentStyle = {
    display: "flex",
    flexDirection: "row", // Horizontal layout
    alignItems: "center",
    gap: "0.75rem",
    width: "100%",
  };

  // const featureIconStyle = {
  //   fontSize: "1.5rem",
  // };

  const featureIconStyle = {
    fontSize: "1.5rem",
  };

  // const featureTextStyle = {
  //   color: "#374151",
  //   fontWeight: "bold",
  //   fontSize: "1rem",
  // };

  const featureTextStyle = {
    color: "#374151",
    fontWeight: "bold",
    fontSize: "1rem",
    whiteSpace: "nowrap", // Prevents text from wrapping
  };

  const socialSectionStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "1.5rem",
  };

  const socialTitleStyle = {
    fontSize: "1.5rem",
    fontWeight: "bold",
    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
  };

  const socialLinksStyle = {
    display: "flex",
    gap: "1.5rem",
  };

  const socialLinkStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#ffffff",
    color: "#7C3AED",
    fontSize: "1.5rem",
    textDecoration: "none",
    boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
    transition: "all 0.3s ease",
  };

  return (
    <>
      {/* Google Analytics */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-RZPVNZL41J"
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-RZPVNZL41J');
        `,
        }}
      />
      <div style={containerStyle}>
        {/* Floating Background Elements */}
        <div style={floatingStyle1}></div>
        <div style={floatingStyle2}></div>

        <div style={mainContentStyle}>
          {/* Logo Section */}
          <div style={logoSectionStyle}>
            <div style={{ position: "relative", marginBottom: "1rem" }}>
              <img
                src="/logo-v2.gif"
                alt="BitcoinFOMO Logo"
                style={logoImageStyle}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  fontSize: "clamp(2rem, 5vw, 4rem)",
                  color: "#FEF08A",
                  textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                ₿
              </div>
              <h1 style={titleStyle}>BitcoinFOMO</h1>
            </div>
            <p style={taglineStyle}>Don't Miss Out Again - Join Now!</p>
          </div>

          {/* Hero Section */}
          <div style={heroStyle}>
            <h2 style={subtitleStyle}>BitcoinFOMO is in development</h2>
            <p style={descriptionStyle}>
              Sign up for project updates and launch news
            </p>
          </div>

          {/* Email Signup */}
          <div style={formSectionStyle}>
            <h3 style={formTitleStyle}>Get Exclusive Early Access</h3>
            <p style={formDescStyle}>
              Join the VIP list and be the first to know when we launch
            </p>

            <div style={inputContainerStyle}>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email for VIP "
                style={inputStyle}
              />
              <button onClick={handleSubmit} style={buttonStyle}>
                🚀 Join Waitlist
              </button>
            </div>

            {message && (
              <div
                style={{
                  ...messageStyle,
                  backgroundColor: message.startsWith("✅")
                    ? "#D1FAE5"
                    : "#FEE2E2",
                  color: message.startsWith("✅") ? "#065F46" : "#991B1B",
                  border: `2px solid ${
                    message.startsWith("✅") ? "#10B981" : "#EF4444"
                  }`,
                }}
              >
                {message}
              </div>
            )}
          </div>

          {/* Features Grid */}
          <div>
            <h3
              style={{
                fontSize: "2rem",
                fontWeight: "bold",
                marginBottom: "2rem",
                textShadow: "0 2px 4px rgba(0,0,0,0.5)",
              }}
            >
              Why BitcoinFOMO?
            </h3>
            <div style={featuresGridStyle}>
              {features.map((feature, index) => (
                <div
                  key={index}
                  style={featureCardStyle}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-5px) scale(1.02)";
                    e.target.style.backgroundColor = "#ffffff";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0) scale(1)";
                    e.target.style.backgroundColor =
                      "rgba(255, 255, 255, 0.95)";
                  }}
                >
                  <div style={featureContentStyle}>
                    <div style={featureIconStyle}>{feature.icon}</div>
                    <span style={featureTextStyle}>{feature.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Social Links */}
          <div style={socialSectionStyle}>
            <h3 style={socialTitleStyle}>Join the Community</h3>
            <div style={socialLinksStyle}>
              <a
                href="https://x.com/RealBTCFOMO"
                style={socialLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
              >
                🐦
              </a>
              <a
                href="http://t.me/RealBitcoinFOMO"
                style={socialLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
              >
                ✈️
              </a>
              <a
                href="https://discord.com/users/1421504291566522430"
                style={socialLinkStyle}
                target="_blank"
                rel="noopener noreferrer"
              >
                👾
              </a>
            </div>
          </div>

          {/* Footer */}
          <footer
            style={{
              textAlign: "center",
              padding: "2rem 0",
              fontSize: "1rem",
              textShadow: "0 2px 4px rgba(0,0,0,0.5)",
            }}
          >
            <p>
              © 2025 BitcoinFOMO. Built for the community, by the community.
            </p>
            <div
              style={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "center",
                gap: "1.5rem",
                flexWrap: "wrap",
              }}
            >
              <a
                href="#"
                style={{
                  color: "#FEF08A",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
                onClick={() => setModal("terms")}
              >
                Terms of Use
              </a>
              <a
                href="#"
                style={{
                  color: "#FEF08A",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
                onClick={() => setModal("privacy")}
              >
                Privacy Policy
              </a>
              <a
                href="#"
                style={{
                  color: "#FEF08A",
                  textDecoration: "underline",
                  fontWeight: "bold",
                }}
                onClick={() => setModal("disclaimers")}
              >
                Disclaimers
              </a>
            </div>
          </footer>

          {/* Modal for Terms, Privacy, Disclaimers */}
          <Modal
            title={
              modal === "terms"
                ? "Terms of Use"
                : modal === "privacy"
                ? "Privacy Policy"
                : modal === "disclaimers"
                ? "Disclaimers"
                : ""
            }
            open={!!modal}
            onClose={() => setModal("")}
          >
            {modal === "terms" && (
              <div
                style={{
                  maxWidth: 700,
                  margin: "2rem auto",
                  padding: "2.5rem 2rem",
                  background: "#fff",
                  color: "#222",
                  borderRadius: 18,
                  boxShadow: "0 8px 32px #0002",
                  fontFamily: "Inter, Arial, sans-serif",
                  lineHeight: 1.8,
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    borderBottom: "2px solid #A855F7",
                    marginBottom: "2rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2.3rem",
                      fontWeight: 900,
                      color: "#7C3AED",
                      margin: 0,
                      letterSpacing: "-1px",
                    }}
                  >
                    Terms of Use
                  </h1>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "1rem",
                      margin: "0.5rem 0 0 0",
                    }}
                  >
                    <strong>Last Updated:</strong> [10, 2025]
                  </p>
                </div>

                <section style={{ marginBottom: "2rem" }}>
                  <p>
                    Welcome to BitcoinFOMO (“Company,” “we,” “our,” or “us”). By
                    accessing or using our website at bitcoinfomo.io and any
                    related sub-domains (collectively, the “Site”), you agree to
                    be bound by these Terms of Use (“Terms”). If you do not
                    agree, please do not use the Site.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    1. Use of the Site
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      The Site is provided for informational purposes only to
                      share project updates and collect email addresses for
                      optional updates.
                    </li>
                    <li>
                      You must be at least 18 years old (or the age of majority
                      in your jurisdiction) to use the Site.
                    </li>
                    <li>
                      You agree not to use the Site for any unlawful purpose or
                      in violation of these Terms.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    2. No Offer or Investment Advice
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      Nothing on this Site constitutes an offer to sell or a
                      solicitation to buy any cryptocurrency, security, or
                      financial instrument.
                    </li>
                    <li>
                      Content is provided “as is” without investment, financial,
                      or legal advice.
                    </li>
                    <li>
                      Any references to potential future tokens, features, or
                      launches are preliminary and subject to change.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    3. Privacy
                  </h2>
                  <p>
                    Your use of the Site is also governed by our Privacy Policy,
                    which explains how we collect and use information, including
                    email addresses submitted through our sign-up form.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    4. Intellectual Property
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      All content on the Site—including text, graphics, logos,
                      and designs—is owned by or licensed to BitcoinFOMO and
                      protected by applicable intellectual-property laws.
                    </li>
                    <li>
                      You may view or print content for personal, non-commercial
                      use only.
                    </li>
                    <li>
                      You may not copy, modify, distribute, or create derivative
                      works without our prior written consent.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    5. User Submissions
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      By submitting your email or other information, you
                      represent that it is accurate and that you have the right
                      to provide it.
                    </li>
                    <li>
                      You grant us a non-exclusive, worldwide license to use the
                      submitted email solely to send project updates and related
                      communications.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    6. Third-Party Services & Links
                  </h2>
                  <p>
                    The Site may contain links to third-party websites or
                    services. We are not responsible for the content, privacy
                    policies, or practices of any third parties.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    7. Disclaimers
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      The Site is provided on an “as is” and “as available”
                      basis without warranties of any kind, express or implied.
                    </li>
                    <li>
                      We do not warrant that the Site will be uninterrupted,
                      error-free, or secure.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    8. Limitation of Liability
                  </h2>
                  <p>
                    To the fullest extent permitted by law, BitcoinFOMO and its
                    affiliates shall not be liable for any indirect, incidental,
                    special, or consequential damages arising from or related to
                    your use of the Site.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    9. Indemnification
                  </h2>
                  <p>
                    You agree to indemnify and hold harmless BitcoinFOMO, its
                    affiliates, and their respective officers, employees, and
                    agents from any claims or demands arising out of your use of
                    the Site or violation of these Terms.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    10. Changes to the Terms
                  </h2>
                  <p>
                    We may update these Terms from time to time. Material
                    changes will be posted on this page with a new “Last
                    Updated” date. Your continued use of the Site after changes
                    constitutes acceptance of the revised Terms.
                  </p>
                </section>

                <section>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    11. Governing Law
                  </h2>
                  <p>
                    These Terms are governed by the laws of the State of New
                    York, without regard to its conflict-of-laws principles. Any
                    disputes will be resolved exclusively in the courts located
                    in New York.
                  </p>
                </section>
              </div>
            )}
            {modal === "privacy" && (
              <div
                style={{
                  maxWidth: 700,
                  margin: "2rem auto",
                  padding: "2.5rem 2rem",
                  background: "#fff",
                  color: "#222",
                  borderRadius: 18,
                  boxShadow: "0 8px 32px #0002",
                  fontFamily: "Inter, Arial, sans-serif",
                  lineHeight: 1.8,
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    borderBottom: "2px solid #A855F7",
                    marginBottom: "2rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2.3rem",
                      fontWeight: 900,
                      color: "#7C3AED",
                      margin: 0,
                      letterSpacing: "-1px",
                    }}
                  >
                    Privacy Policy
                  </h1>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "1rem",
                      margin: "0.5rem 0 0 0",
                    }}
                  >
                    <strong>Last Updated:</strong> [10, 2025]
                  </p>
                </div>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    1. Overview
                  </h2>
                  <p>
                    BitcoinFOMO (“Company,” “we,” “our,” or “us”) respects your
                    privacy. This Privacy Policy explains how we collect, use,
                    and safeguard information you provide when you visit
                    bitcoinfomo.io or related sub-domains (the “Site”). By using
                    the Site, you consent to the practices described in this
                    Policy.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    2. Information We Collect
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      <strong>Email Address:</strong> If you choose to join our
                      update list, we collect the email address you voluntarily
                      provide.
                    </li>
                    <li>
                      <strong>Automatic Data:</strong> Like most websites, we
                      may collect limited technical information (e.g., IP
                      address, browser type, pages visited) through cookies or
                      similar technologies for site functionality and analytics.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    3. How We Use Your Information
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      Send occasional project updates or launch announcements
                      (only if you subscribed).
                    </li>
                    <li>Operate, maintain, and improve the Site.</li>
                    <li>
                      Comply with legal obligations and protect our rights.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    4. Legal Bases for Processing (EU/UK Visitors)
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      <strong>Consent:</strong> when you voluntarily subscribe
                      to our email list.
                    </li>
                    <li>
                      <strong>Legitimate Interests:</strong> to maintain basic
                      site security and functionality.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    5. Sharing & Disclosure
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>We do not sell or rent your personal information.</li>
                    <li>
                      We may share data only with:
                      <ul style={{ marginLeft: "1.5rem" }}>
                        <li>
                          <strong>Service Providers</strong> who help operate
                          our email list or website (bound by confidentiality
                          agreements).
                        </li>
                        <li>
                          <strong>Legal Authorities</strong> if required by law
                          or to protect our rights.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    6. Cookies & Tracking
                  </h2>
                  <p>
                    We may use first-party cookies for essential site
                    performance and anonymous analytics. You can control cookies
                    through your browser settings.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    7. Data Retention
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>
                      Email addresses are retained until you unsubscribe or
                      request deletion.
                    </li>
                    <li>
                      Technical logs are retained for a reasonable period for
                      security and maintenance.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    8. Your Rights
                  </h2>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: "1rem",
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>Access, correct, or delete your personal data.</li>
                    <li>Withdraw consent or object to processing.</li>
                    <li>Request data portability.</li>
                  </ul>
                  <p>
                    To exercise these rights, email us at{" "}
                    <a href="mailto:privacy@bitcoinfomo.io">
                      privacy@bitcoinfomo.io
                    </a>
                    .
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    9. Data Security
                  </h2>
                  <p>
                    We use commercially reasonable safeguards to protect your
                    information, but no method of transmission or storage is
                    completely secure.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    10. International Transfers
                  </h2>
                  <p>
                    Your information may be processed in countries outside your
                    residence, including the United States. We take appropriate
                    steps to ensure an adequate level of protection.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    11. Children’s Privacy
                  </h2>
                  <p>
                    The Site is not directed to individuals under 18. We do not
                    knowingly collect personal information from children.
                  </p>
                </section>

                <section>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    12. Changes to This Policy
                  </h2>
                  <p>
                    We may update this Privacy Policy from time to time.
                    Material changes will be posted on this page with a new
                    “Last updated” date.
                  </p>
                </section>
              </div>
            )}
            {modal === "disclaimers" && (
              <div
                style={{
                  maxWidth: 700,
                  margin: "2rem auto",
                  padding: "2.5rem 2rem",
                  background: "#fff",
                  color: "#222",
                  borderRadius: 18,
                  boxShadow: "0 8px 32px #0002",
                  fontFamily: "Inter, Arial, sans-serif",
                  lineHeight: 1.8,
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    borderBottom: "2px solid #A855F7",
                    marginBottom: "2rem",
                    paddingBottom: "1rem",
                  }}
                >
                  <h1
                    style={{
                      fontSize: "2.3rem",
                      fontWeight: 900,
                      color: "#7C3AED",
                      margin: 0,
                      letterSpacing: "-1px",
                    }}
                  >
                    Disclaimer
                  </h1>
                  <p
                    style={{
                      color: "#666",
                      fontSize: "1rem",
                      margin: "0.5rem 0 0 0",
                    }}
                  >
                    <strong>Last Updated:</strong> [10, 2025]
                  </p>
                </div>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    1. Informational Purposes Only
                  </h2>
                  <p style={{ marginBottom: "0.5rem" }}>
                    The information provided on this website, including any
                    updates you may receive after subscribing, is for general
                    informational purposes only and does not constitute:
                  </p>
                  <ul
                    style={{
                      marginLeft: "1.5rem",
                      marginBottom: 0,
                      color: "#444",
                      fontSize: "1rem",
                    }}
                  >
                    <li>an offer to sell,</li>
                    <li>a solicitation to buy, or</li>
                    <li>
                      financial or investment advice with respect to any
                      cryptocurrency, digital asset, security, or other
                      financial instrument.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    2. Project Status
                  </h2>
                  <p>
                    <span
                      style={{
                        background: "#F3F4F6",
                        padding: "0.15rem 0.4rem",
                        borderRadius: "6px",
                      }}
                    >
                      BitcoinFOMO is an early-stage project in development.
                    </span>
                    &nbsp;Features, timelines, and specifications described here
                    are subject to change without notice.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem" }}>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    3. No Rights or Guarantees
                  </h2>
                  <p>
                    Participation on the email update list is solely to receive
                    project news and does not grant any rights, privileges, or
                    guarantees of future token allocations.
                  </p>
                </section>

                <section>
                  <h2
                    style={{
                      color: "#A855F7",
                      fontSize: "1.25rem",
                      fontWeight: 700,
                      marginBottom: "0.5rem",
                    }}
                  >
                    4. User Responsibility
                  </h2>
                  <p>
                    Users are responsible for complying with the laws of their
                    jurisdiction before engaging in any cryptocurrency activity.
                  </p>
                </section>
              </div>
            )}
          </Modal>
        </div>

        {/* CSS Animations */}
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 0.3; }
            33% { transform: translateY(-20px) rotate(120deg); opacity: 0.5; }
            66% { transform: translateY(10px) rotate(240deg); opacity: 0.4; }
          }
          
          @keyframes bounce {
            0%, 20%, 53%, 80%, 100% {
              transform: translateY(0px);
            }
            40%, 43% {
              transform: translateY(-15px);
            }
            70% {
              transform: translateY(-7px);
            }
            90% {
              transform: translateY(-3px);
            }
          }
          
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
            }
            50% {
              opacity: 0.7;
              transform: scale(1.05);
            }
          }

          button:hover {
            transform: translateY(-2px) scale(1.05);
            box-shadow: 0 15px 35px rgba(245, 158, 11, 0.4);
          }

          input:focus {
            border-color: #FEF08A;
            box-shadow: 0 0 20px rgba(254, 240, 138, 0.5);
          }

          input::placeholder {
            color: #6B7280;
            opacity: 1;
            font-weight: 500;
          }

          input::-webkit-input-placeholder {
            color: #6B7280;
            opacity: 1;
            font-weight: 500;
          }

          input::-moz-placeholder {
            color: #6B7280;
            opacity: 1;
            font-weight: 500;
          }

          input:-ms-input-placeholder {
            color: #6B7280;
            opacity: 1;
            font-weight: 500;
          }
        `,
          }}
        />
      </div>
    </>
  );
};

export default CountDownPage;
